import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button } from '../../../../components/Button';
import { Container } from './styles';

export const PremiumBanner = () => {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <Container onClick={() => history.push('/subscription/features')}>
            <div className="left-section">
                <h4>{t('components.bannerPremium.title')} 🔥</h4>
                <p>{t('components.bannerPremium.description')}</p>
            </div>
            <div className="right-section">
                <Button type="NEUTRAL" size="MD" className="button">
                    {t('components.bannerPremium.buttonTitle')}
                </Button>
            </div>
        </Container>
    );
};
